import { render, staticRenderFns } from "./modal-authorize.vue?vue&type=template&id=0c431891"
import script from "./modal-authorize.ts?vue&type=script&lang=js&external"
export * from "./modal-authorize.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports